// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nbutton + button[data-v-60a04bed] {\n    margin-left: 12px;\n}\n", ""]);
// Exports
module.exports = exports;
